var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Navbar",
    transform: "translate(-40.000000, -254.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons",
    transform: "translate(25.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Button",
    transform: "translate(0.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-solid",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,10.5 C11.840625,10.5 14.1428571,8.14980469 14.1428571,5.25 C14.1428571,2.35019531 11.840625,0 9,0 C6.159375,0 3.85714286,2.35019531 3.85714286,5.25 C3.85714286,8.14980469 6.159375,10.5 9,10.5 Z M12.6,11.8125 L11.9290179,11.8125 C11.0370536,12.2308594 10.0446429,12.46875 9,12.46875 C7.95535714,12.46875 6.96696429,12.2308594 6.07098214,11.8125 L5.4,11.8125 C2.41875,11.8125 0,14.2816406 0,17.325 L0,19.03125 C0,20.1181641 0.863839286,21 1.92857143,21 L16.0714286,21 C17.1361607,21 18,20.1181641 18,19.03125 L18,17.325 C18,14.2816406 15.58125,11.8125 12.6,11.8125 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.d6d89412fdb6039a1652c19a279063c1.svg";
export { ForwardRef as ReactComponent };